import React, { useState } from "react";
import { useSelector } from "react-redux";
import { TreatmentReportData } from "../components/core/TreatmentReport/treatmentReportData";
import { Header } from "../components/secondary/Header";
import style from "./treatmentReport.module.scss";
import { useExternalUserRedirect } from "../hooks/useExternalUserRedirect";
import { TreatmentReportForm } from "../components/core/TreatmentReport/treatmentReportForm";
import { TreatmentOverview } from "../components/core/TreatmentReport/treatmentOverview";

export const TreatmentReport = () => {
  useExternalUserRedirect();

  const treatmentReportPayload = useSelector((state) => state.woundreport.treatmentReportPayload);

  const [selectedDivOption, setSelectedDivOption] = useState(treatmentReportPayload?.optionSelected ?? "Wound Cleansers");

  return (
    <>
      <div className="right_block">
        <Header reportHeading={"Treatment Outcomes"} />
        <div className={`col ${style.wound_dashboard} mt-0`}>
          <TreatmentReportForm setSelectedDivOption={setSelectedDivOption} />
          <TreatmentOverview selectedDivOption={selectedDivOption} setSelectedDivOption={setSelectedDivOption} />
          <TreatmentReportData tempPayload={treatmentReportPayload} selectedDivOption={selectedDivOption} />,
        </div>
      </div>
    </>
  );
};
